export const referralsKeys = {
  list: ['referrals', 'list'] as const,
} as const
